import { render, staticRenderFns } from "./ConfiguratorLayout.vue?vue&type=template&id=53ca8c26&scoped=true&"
import script from "./ConfiguratorLayout.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorLayout.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorLayout.vue?vue&type=style&index=0&id=53ca8c26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca8c26",
  null
  
)

export default component.exports